import * as React from 'react';

import AnnotationsHighlight16 from './AnnotationsHighlight16';

export const annotationsHighlight16 = () => <AnnotationsHighlight16 />;

export default {
    title: 'Icon|Fill|AnnotationsHighlight16',
    component: AnnotationsHighlight16,
    parameters: {
        notes: "`import AnnotationsHighlight16 from 'box-ui-elements/es/icon/fill/AnnotationsHighlight16';`",
    },
};
